<template>
  <DBox
    :id="'cmp-royalty-contracts-sidewindow-licencing'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('licensing')}`"
    @add_click="onAddLicencing"
  >
    <NTable
      class="dbox1"
      id="royalty-contracts-sidewindow-licencing-list"
      :config="tableConfig"
      :headers="headers"
      :items="list || []"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('channel')">
            <TextField2
              :id="'sequence_no'"
              :showLabel="false"
              :value="item['sequence_no']"
              @blur="e => onTextFieldValueChange(e, item)"
               :bb="'none'"
            />
          </td>
          <td v-bind="tdcon('rate')">
            <!-- <div class="percent-area"> -->
            <TextField2
              :ta="'right'"
              :id="'royalty_rate'"
              :showLabel="false"
              :type="'percent'"
              :value="item['royalty_rate']"
              @blur="e => onTextFieldValueChange(e, item)"
               :bb="'none'"
            />
            <!-- <span class="percent">% income</span> -->
            <!-- </div> -->
          </td>

          <td v-bind="tdcon('adjustment')">
            <!-- <div class="percent-area"> -->
            <TextField2
              :ta="'right'"
              :id="'ppu_adjustment'"
              :showLabel="false"
              :type="'percent'"
              :value="item['ppu_adjustment']"
              @blur="e => onTextFieldValueChange(e, item)"
               :bb="'none'"
            />
            <!-- <span class="percent">%</span> -->
            <!-- </div> -->
          </td>
          <td v-bind="tdcon('deduction1')">
            <!-- <div class="percent-area"> -->
            <TextField2
              :ta="'right'"
              :id="'deduction1'"
              :showLabel="false"
              :type="'percent'"
              :value="item['deduction1']"
              @blur="e => onTextFieldValueChange(e, item)"
               :bb="'none'"
            />
            <!-- <span class="percent">%</span> -->
            <!-- </div> -->
          </td>
          <td v-bind="tdcon('territory')">
            <Dropdown
              class="dbox1"
              :showLabel="false"
              :options="territoryTV"
              deselect
              :selected="territoryTV.find(e => e.value == item.territory_id)"
              :placeholder="$t('territory')"
              v-on:selectedChange="
                e => onTerritoryChange('territory_id', e, item)
              "
               :bb="'none'"
            ></Dropdown>
          </td>
          <td v-bind="tdcon('type')">
            <!-- [{text: 'one', value: 1}, 
              {text: 'two', value: 2}] -->
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :options="typeTV"
              deselect
              :selected="typeTV.find(e => e.text.toLowerCase() == item.license_type)"
              :placeholder="$t('license_type')"
              v-on:selectedChange="
                e => onLicenseTypeChange('license_type', e, item)
              "
               :bb="'none'"
            />
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="e => onDeleteLicencing(item)"
              class="dt-icon v5 s1 ut-center"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { ContractsService } from "../../services/contracts.service";
import { createTV } from "../../../../models/text-value.model";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["channel", "list", "selectedContractDetails"],
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    headers: function() {
      return [
        createTableHeader("channel", { mw: 80, text: this.channel }),
        createTableHeader("rate", {
          mw: 70,
          ta: "right"
        }),
        createTableHeader("adjustment", {
          mw: 110,
          ta: "right"
        }),
        createTableHeader("deduction1", {
          mw: 110,
          ta: "right"
        }),
        createTableHeader("territory"),
        createTableHeader("type"),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    },
    contract_id: function() {
      return this.$route.params.contract_id;
    },

    reserveTypeTV: function() {
      return [
        { text: "Net Amount", value: 1 },
        { text: "by Catalog No", value: 2 }
      ];
    },
    typeTV: function() {
      return createTV(
        this.selectedContractDetails.license_types,
        "label_status_name",
        "label_status_id"
      );
    },
    territoryTV: function() {
      return createTV(
        this.selectedContractDetails.territories,
        "label",
        "value"
      );
    }
  },
  methods: {
    onTextFieldValueChange: function({ name, value }, item) {
      this.$emit("changed", { name, value, item });
    },

    onTerritoryChange: function(name, e, item) {
      this.$emit("changed", { name, value: e.value, item });
    },
    onLicenseTypeChange: function(name, e, item) {

      console.log(e,"::::::")

      const value = name==='license_type'?e.text.toLowerCase():e.value;

      this.$emit("changed", { name, value: value, item });
    },

    onAddLicencing: async function() {
      const res = await ContractsService.addLicensing(this.contract_id);
      this.$emit("added", {
        ...res.data,
        channel: this.channel
      });
    },

    onDeleteLicencing: async function(item) {
      this.$emit("deleted", item);
      // const confirmationResult = await confirmDelete(
      //   "licencing",
      //   item.sequence_no
      // );
      // if (confirmationResult === "OK") {
      //   this.$emit("deleted", item);
      // }
    }
  }
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-licencing {
  .percent-area {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 3px !important;
    margin-left: 3px !important;

    .fc2-textfield {
      flex: 1;
      width: 50%;
    }

    .percent {
      display: block;
    }
  }
}
</style>
